<template>
  <Teleport to="body">
  <div class="modal fade payroll-setup-modal" id="deductionTypesManagementModal" tabindex="-1" aria-labelledby="deductionTypesManagementModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deductionTypesManagementModalLabel">Deduction Types Management</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading deduction types...</p>
          </div>

          <div v-else>
            <!-- Controls section -->
            <div class="d-flex justify-content-between mb-3">
              <h6 class="mb-0 mt-2">Manage Deduction Types</h6>
              <button @click="showAddModal" class="btn btn-sm btn-primary">
                <i class="mdi mdi-plus me-1"></i> Add Deduction Type
              </button>
            </div>

            <!-- Deduction types table -->
            <div class="table-responsive">
              <table class="table table-sm table-hover table-bordered">
                <thead class="table-light">
                <tr>
                  <th>Deduction Name</th>
                  <th>Amount Type</th>
                  <th>Default Value</th>
                  <th>Pre-Tax</th>
                  <th>Mandatory</th>
                  <th>Description</th>
                  <th class="text-center">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="deductionTypes.length === 0">
                  <td colspan="7" class="text-center py-3">No deduction types found</td>
                </tr>
                <tr v-for="deduction in deductionTypes" :key="deduction.id">
                  <td>{{ deduction.deduction_name }}</td>
                  <td>{{ deduction.is_percentage === '1' ? 'Percentage' : 'Fixed Amount' }}</td>

                  <td>
                    {{ deduction.is_percentage === '1'
                      ? deduction.default_percentage + '%'
                      : formatCurrency(deduction.default_amount) }}
                  </td>

                  <td>
                   <span class="badge" :class="deduction.is_pretax === '1' ? 'bg-info' : 'bg-secondary'">
  {{ deduction.is_pretax === '1' ? 'Yes' : 'No' }}
</span>

                  </td>
                  <td>
                  <span class="badge" :class="deduction.is_mandatory === '1' ? 'bg-danger' : 'bg-secondary'">
  {{ deduction.is_mandatory === '1' ? 'Yes' : 'No' }}
</span>

                  </td>
                  <td>{{ deduction.description || 'N/A' }}</td>
                  <td class="text-center">
                    <button @click="editDeductionType(deduction)" class="btn btn-sm btn-info me-1">
                      <i class="mdi mdi-pencil"></i>
                    </button>
                    <button @click="deleteDeductionType(deduction.id)" class="btn btn-sm btn-danger">
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Close</button>
        </div>
      </div>
    </div>
  </div>
  </Teleport>

  <!-- Add/Edit Deduction Type Modal -->
  <Teleport to="body">
  <div class="modal fade payroll-setup-modal" id="deductionTypeFormModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditing ? 'Edit Deduction Type' : 'Add Deduction Type' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveDeductionType">
            <div class="mb-3">
              <label for="deductionName" class="form-label">Deduction Name <span class="text-danger">*</span></label>
              <input
                  type="text"
                  class="form-control"
                  id="deductionName"
                  v-model="deductionForm.deduction_name"
                  required
              >
            </div>

            <div class="mb-3">
              <label class="form-label">Amount Type <span class="text-danger">*</span></label>
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    id="deduction-fixed-amount"
                    value="fixed"
                    v-model="deductionForm.amount_type"
                >
                <label class="form-check-label" for="deduction-fixed-amount">Fixed Amount</label>
              </div>
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    id="deduction-percentage"
                    value="percentage"
                    v-model="deductionForm.amount_type"
                >
                <label class="form-check-label" for="deduction-percentage">Percentage of Basic Salary</label>
              </div>
            </div>

            <div class="mb-3" v-if="deductionForm.amount_type === 'fixed'">
              <label for="deductionDefaultAmount" class="form-label">Default Amount</label>
              <div class="input-group">
                <span class="input-group-text">KES</span>
                <input
                    type="number"
                    class="form-control"
                    id="deductionDefaultAmount"
                    v-model="deductionForm.default_amount"
                    min="0"
                    step="0.01"
                >
              </div>
            </div>

            <div class="mb-3" v-if="deductionForm.amount_type === 'percentage'">
              <label for="deductionDefaultPercentage" class="form-label">Default Percentage</label>
              <div class="input-group">
                <input
                    type="number"
                    class="form-control"
                    id="deductionDefaultPercentage"
                    v-model="deductionForm.default_percentage"
                    min="0"
                    max="100"
                    step="0.01"
                >
                <span class="input-group-text">%</span>
              </div>
            </div>

            <div class="mb-3">
              <div class="form-check mb-2">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="isPretax"
                    v-model="deductionForm.is_pretax"
                >
                <label class="form-check-label" for="isPretax">
                  Pre-Tax Deduction
                </label>
              </div>
              <small class="text-muted d-block mb-3">If checked, this deduction will be applied before tax calculation</small>

              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="isMandatory"
                    v-model="deductionForm.is_mandatory"
                >
                <label class="form-check-label" for="isMandatory">
                  Mandatory Deduction
                </label>
              </div>
              <small class="text-muted">If checked, this deduction will be automatically applied to all eligible employees</small>
            </div>

            <div class="mb-3">
              <label for="deductionDescription" class="form-label">Description</label>
              <textarea
                  class="form-control"
                  id="deductionDescription"
                  v-model="deductionForm.description"
                  rows="3"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Cancel</button>
          <button
              type="button"
              class="btn btn-primary"
              @click="saveDeductionType"
              :disabled="!isFormValid || submitLoading"
          >
            <span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Update' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script>
/* eslint-disable */
import * as bootstrap from "bootstrap";
import { authUrl, execute } from "@/api";

export default {
  name: 'DeductionTypesManagement',
  data() {
    return {
      loading: false,
      submitLoading: false,
      deductionTypes: [],
      isEditing: false,
      currentId: null,
      deductionForm: {
        deduction_name: '',
        amount_type: 'fixed',
        default_amount: '',
        default_percentage: '',
        is_pretax: true,
        is_mandatory: false,
        description: ''
      },
      modal: null,
      formModal: null
    };
  },
  computed: {
    isFormValid() {
      if (!this.deductionForm.deduction_name) return false;

      if (this.deductionForm.amount_type === 'fixed') {
        return true; // Default amount is optional
      } else if (this.deductionForm.amount_type === 'percentage') {
        return true; // Default percentage is optional
      }

      return true;
    }
  },
  mounted() {
    this.initModals();
  },
  methods: {
    initModals() {
      this.$nextTick(() => {
        // Initialize the main modal
        this.modal = new bootstrap.Modal(document.getElementById('deductionTypesManagementModal'));

        // Initialize form modal
        this.formModal = new bootstrap.Modal(document.getElementById('deductionTypeFormModal'));

        // Listen for modal hidden events to reset form
        document.getElementById('deductionTypeFormModal').addEventListener('hidden.bs.modal', this.resetForm);
      });
    },
    showModal() {
      if (this.modal) {
        this.loadDeductionTypes();
        this.modal.show();
      } else {
        this.initModals();
        setTimeout(() => {
          if (this.modal) {
            this.loadDeductionTypes();
            this.modal.show();
          }
        }, 100);
      }
    },
    hideModal() {
      if (this.modal) {
        this.modal.hide();
      }
    },
    showAddModal() {
      this.isEditing = false;
      this.currentId = null;
      this.resetForm();
      if (this.formModal) {
        this.formModal.show();
      }
    },
    showEditModal() {
      if (this.formModal) {
        this.formModal.show();
      }
    },
    hideFormModal() {
      if (this.formModal) {
        this.formModal.hide();
      }
    },
    resetForm() {
      this.deductionForm = {
        deduction_name: '',
        amount_type: 'fixed',
        default_amount: '',
        default_percentage: '',
        is_pretax: true,
        is_mandatory: false,
        description: ''
      };
      this.submitLoading = false;
    },
    loadDeductionTypes() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getDeductionTypes");

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              this.deductionTypes = res.data.data.deductionTypes || [];
            } else {
              console.error("Error fetching deduction types:", res.data.message);
              alert(res.data.message || "Failed to load deduction types");
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error("API Error:", error);
            alert("An error occurred while loading deduction types");
          });
    },
    editDeductionType(deduction) {
      this.isEditing = true;
      this.currentId = deduction.id;

      // Copy deduction data to form - Fixed boolean conversion
      this.deductionForm = {
        deduction_name: deduction.deduction_name,
        amount_type: deduction.is_percentage === '1' ? 'percentage' : 'fixed',
        default_amount: deduction.default_amount || '',
        default_percentage: deduction.default_percentage || '',
        is_pretax: deduction.is_pretax === '1',  // Convert string to boolean
        is_mandatory: deduction.is_mandatory === '1',  // Convert string to boolean
        description: deduction.description || ''
      };

      this.showEditModal();
    },
    deleteDeductionType(id) {
      if (!confirm("Are you sure you want to delete this deduction type? This may affect employee deductions.")) {
        return;
      }

      this.loading = true;

      const data = new FormData();
      data.append("function", "deleteDeductionType");
      data.append("id", id);

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              alert(res.data.message || "Deduction type deleted successfully");
              this.loadDeductionTypes();
            } else {
              alert(res.data.message || "Failed to delete deduction type");
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error("API Error:", error);
            alert("An error occurred while deleting deduction type");
          });
    },
    saveDeductionType() {
      if (!this.isFormValid) {
        alert("Please fill all required fields");
        return;
      }

      this.submitLoading = true;

      const data = new FormData();
      data.append("function", this.isEditing ? "updateDeductionType" : "createDeductionType");

      if (this.isEditing) {
        data.append("id", this.currentId);
      }

      data.append("deduction_name", this.deductionForm.deduction_name);
      data.append("is_percentage", this.deductionForm.amount_type === 'percentage' ? 1 : 0);
      data.append("is_pretax", this.deductionForm.is_pretax ? 1 : 0);
      data.append("is_mandatory", this.deductionForm.is_mandatory ? 1 : 0);

      if (this.deductionForm.amount_type === 'fixed' && this.deductionForm.default_amount) {
        data.append("default_amount", this.deductionForm.default_amount);
      }

      if (this.deductionForm.amount_type === 'percentage' && this.deductionForm.default_percentage) {
        data.append("default_percentage", this.deductionForm.default_percentage);
      }

      if (this.deductionForm.description) {
        data.append("description", this.deductionForm.description);
      }

      execute(data, authUrl)
          .then((res) => {
            this.submitLoading = false;

            if (res.data.success) {
              alert(res.data.message || (this.isEditing ? "Deduction type updated successfully" : "Deduction type created successfully"));
              this.hideFormModal();
              this.loadDeductionTypes();
            } else {
              alert(res.data.message || "Failed to save deduction type");
            }
          })
          .catch((error) => {
            this.submitLoading = false;
            console.error("API Error:", error);
            alert("An error occurred while saving deduction type");
          });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value || 0);
    }
  }
};
</script>

<style scoped>
.form-check {
  margin-bottom: 0.5rem;
}

.alert {
  margin-top: 1rem;
}
</style>